import React, { useState } from "react";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import {
  Container,
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Alert,
  Link,
} from "@mui/material";
import passwordAPI from "../utils/passwordAPI";

const ResetPassword = () => {
  const [universityId, setUniversityId] = useState("");
  const [maskedEmail, setMaskedEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setMaskedEmail("");
    try {
      const { data } = await passwordAPI.findByUniversityId(universityId);
      setMaskedEmail(data.maskedEmail);
      // Send reset link
      await passwordAPI.resetByUniversityId(universityId);
      setMessage(
        `A password reset link has been sent to ${data.maskedEmail}. Please check your email.`
      );
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Unable to process request. Please verify your University ID and try again."
      );
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          mt: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Paper sx={{ p: 4, width: "100%", borderRadius: 2 }} elevation={3}>
          <Typography variant="h4" align="center" gutterBottom>
            Reset Password
          </Typography>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          {message && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {message}
            </Alert>
          )}
          {!message && (
            <Box component="form" onSubmit={handleSubmit} noValidate>
              <TextField
                margin="normal"
                required
                fullWidth
                label="University ID"
                value={universityId}
                onChange={(e) => setUniversityId(e.target.value)}
                autoFocus
              />
              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{ mt: 2 }}
              >
                Send Reset Link
              </Button>
            </Box>
          )}
          <Box sx={{ mt: 3, textAlign: "center" }}>
            <Link component={RouterLink} to="/login">
              Back to Login
            </Link>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default ResetPassword;
